import { publish } from '../utils/pubsub';
import { events } from './SystemEvents';

function createEvent(id, name) {
    return {
        id,
        name,
    };
}

const systemEvents = [createEvent(1, 'OnTrendTickersChanged')];

class SystemEventPublisher {
    pubId = (id) => {
        const r = systemEvents.find((x) => x.id === id);
        if (!r) {
            publish('OnSystemEvent', r);
        }

        return r;
    };

    /**
     *
     * publish an event with data for target component
     *
     * @param {string} e name of event, see events
     * @param {any} data event data
     * @param {string} target event target name aka component for which this event is undefined for all
     */
    pubEvent = (e, data, target) => {
        publish(events.onSystemEvent, { name: e, data, target });
    };
}

const publisher = new SystemEventPublisher();
export default publisher;
